import * as React from 'react';

const RightArrow = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      // eslint-disable-next-line max-len
      d="M8.23438 16.834L13.4683 11.6L8.23438 6.36604C8.19531 6.32698 8.16114 6.28489 8.13184 6.24051C7.94714 5.96079 7.95651 5.59065 8.15991 5.32009C8.18237 5.29022 8.20719 5.26156 8.23438 5.23438C8.31792 5.15084 8.41534 5.08963 8.51921 5.05075C8.65819 4.99874 8.80872 4.98671 8.95305 5.01465C9.10436 5.04394 9.24885 5.11719 9.36604 5.23438L15.1658 11.0341C15.3159 11.1843 15.4002 11.3878 15.4002 11.6C15.4002 11.8123 15.3159 12.0158 15.1658 12.1659L9.36604 17.9656C9.05354 18.2781 8.54688 18.2781 8.23438 17.9656C8.19531 17.9266 8.16114 17.8845 8.13184 17.8401C7.92676 17.5295 7.96094 17.1074 8.23438 16.834Z"
      fill="#71717A"
    />
  </svg>
);
export default RightArrow;
